import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Logout from '@mui/icons-material/Logout';
import Button from '@mui/material/Button';
import { Badge, ManageAccounts, TableRestaurant } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import SchoolIcon from '@mui/icons-material/School';

const mainListItems = [
  // { text: 'Home', url: '/app', icon: <Home /> },
  { text: 'Classes', url: '/app', icon: <TableRestaurant /> },
  // { text: 'Groups', url: '/app/groups', icon: <People /> },
  { text: 'Students', url: '/app/students', icon: <SchoolIcon /> },
  // { text: 'History', url: '/app/history', icon: <Schedule /> },
  { text: 'Users', url: '/app/users', icon: <Badge /> },
  { text: 'Managed Users', url: '/app/users/managed', icon: <ManageAccounts /> },
];

const secondaryListItems = [
  { text: 'Logout', icon: <Logout /> },
];

export default function MenuContent() {
  const location = useLocation();
  const { logout } = useAuth();

  async function handleLogout() {
    await logout();
  }

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {/* <Button startIcon={<Home />} sx={{justifyContent: 'left', paddingLeft: 2}}><span>Home</span></Button> */}
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton href={item.url} sx={{ height: 40 }} selected={location.pathname === item.url}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List>
        <Button onClick={handleLogout} startIcon={<Logout />} sx={{ justifyContent: 'left', paddingLeft: 2 }}>Sign Out</Button>
      </List>
      {/* <List>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
    </Stack>
  );
}
